<template>

  <div class="animated fadeIn" >
      <br>
      <div  align="center">
      <b-button  variant="primary" class="fa fa-print btn-lg" @click="printDiv" title="Imprimir"></b-button> 
      &nbsp;
       <b-button  variant="primary" class="fa fa-file-pdf-o btn-lg" @click="descargarPDF" title="Descargar PDF"></b-button>
      </div>
      <hr/>
      <b-card-body >
        <!-- <b-row class="mb-4" align="center">
          <b-col sm="4">
            <div><strong>GUIA:</strong> {{waybillData.numero_guia}}</div>
            <div><strong>EXPORTADORA:</strong> {{waybillData.client_customer.text}}</div>
            <div><strong>EMPRESA:</strong> {{waybillData.company.text}}</div>
          </b-col>
          <b-col sm="4">
            <div><strong>NOMBRE CHOFER:</strong> {{waybillData.truck_driver}}</div>
            <div><strong>PATENTE:</strong> {{waybillData.license_plate}}</div>
          </b-col>
          <b-col sm="4">
             <div> <strong>FECHA GUIA:</strong> {{waybillData.waybill_date.split("-").reverse().join("/")}}</div>
           <div><strong>NOTA PRODUCTOR:</strong> {{waybillData.internal_note}}</div>
          </b-col>
        </b-row> -->
        <div class="table-responsive-sm">
          <table class="table table-striped table-bordered" border="1" id="dataTable" style="text-align: center;">
            <thead >
              <tr >
                <th align="center">#</th>
                <th align="center">NUMERO</th>
                <th class="center">PRODUCTO</th>
                <th class="center">VARIEDAD</th>
                <th class="center">ORIGEN</th>
                <th class="center">TIPO PRODUCTO</th>
                <th class="center">CONDICIÓN</th>
                <th class="center">ENVASE</th>
                <th class="center">CAJAS</th>
                <th class="center">Especificación</th>
                <th class="center">KILOS BRUTOS</th>
                <th class="center">KILOS NETOS</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row,indice) in tableDataPalletGuia">
                  <template template v-for="(row2, index) in row.contents_data">
                      <template v-if="index == 0">
                      <tr>
                      <td class="center table-light" style="display: table-cell;vertical-align: middle;" :rowspan="row.total_contents" ><b>{{indice=indice + 1}}</b></td>
                      <td class="center " style="display: table-cell;vertical-align: middle;" :rowspan="row.total_contents" ><b>{{row.Numero}}</b></td>
                      <td class="center">{{row2.product_name}}</td>
                      <td class="center">{{row2.variety_name}}</td>
                      <td class="center">{{row2.origin_name}}</td>
                      <td class="center">{{row2.product_type_name}}</td>
                      <td class="center">{{row2.condition}}</td>
                      <td class="center">{{row2.container_name}}</td>
                      <td class="center">{{row2.quantity}}</td>
                      <td class="center">{{row2.specifications}}</td>
                      <td class="center">{{row2.gross_kilograms}}</td>
                      <td class="center">{{row2.net_kilograms}}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                      <td class="center">{{row2.product_name}}</td>
                      <td class="center">{{row2.variety_name}}</td>
                      <td class="center">{{row2.origin_name}}</td>
                      <td class="center">{{row2.product_type_name}}</td>
                      <td class="center">{{row2.condition}}</td>
                      <td class="center">{{row2.container_name}}</td>
                      <td class="center">{{row2.quantity}}</td>
                      <td class="center">{{row2.specifications}}</td>
                      <td class="center">{{row2.gross_kilograms}}</td>
                      <td class="center">{{row2.net_kilograms}}</td>
                      </tr>
                    </template>  
                  </template>
              </template>
                      <tr class="table-light">
                      <td class="center"><b>TOTAL:</b></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"><b> {{total_cajas}}</b></td>
                      <td class="center"></td>
                      <td class="center"><b>{{total_kg_brutos}}</b></td>
                      <td class="center"><b>{{total_kg_netos}}</b></td>
                      </tr>
            </tbody>
          </table>
        </div>
      </b-card-body>
   
 

<b-card no-body id="areaImprimir" style="display:none" >
<div slot="header">
    <div style="text-align: center;">
    <img class="navbar-brand-full" style=" margin: -60px 0px -100px 0px;" src="img/logo_fruta2.png" width="250" height="300" alt="Logo Empresa">
    </div>
 </div>
      <b-card-body >
        <!-- <b-row class="mb-4" align="center">
          <b-col sm="4">
            <div><strong>GUIA: {{waybillData.numero_guia}}</strong></div>
            <div><strong>EXPORTADORA: {{waybillData.client_customer.text}}</strong></div>
            <div><strong>EMPRESA: {{waybillData.company.text}}</strong></div>
          </b-col>
          <b-col sm="4">
            <div><strong>NOMBRE CHOFER: {{waybillData.truck_driver}}</strong></div>
            <div><strong>PATENTE: {{waybillData.license_plate}}</strong></div>
          </b-col>
          <b-col sm="4">
             <div> <strong>FECHA GUIA: {{waybillData.waybill_date.split("-").reverse().join("/")}}</strong></div>
           <div><strong>NOTA PRODUCTOR: {{waybillData.internal_note}}</strong></div>
          </b-col>
        </b-row> -->
        <div class="table-responsive-sm">
          <table class="table table-striped table-bordered " id="dataTable" style="text-align: center;">
            <thead >
              <tr >
                <th align="center">#</th>
                <th align="center">NUMERO</th>
                <th class="center">PRODUCTO</th>
                <th class="center">VARIEDAD</th>
                <th class="center">ORIGEN</th>
                <th class="center">TIPO PRODUCTO</th>
                <th class="center">CONDICIÓN</th>
                <th class="center">ENVASE</th>
                <th class="center">CAJAS</th>
                <th class="center">Especificación</th>
                <th class="center">KILOS BRUTOS</th>
                <th class="center">KILOS NETOS</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row,indice) in tableDataPalletGuia">
                  <template template v-for="(row2, index) in row.contents_data">
                      <template v-if="index == 0">
                      <tr>
                      <td class="center table-light" style="display: table-cell;vertical-align: middle;" :rowspan="row.total_contents" ><b>{{indice=indice + 1}}</b></td>
                      <td class="center table-secondary" style="display: table-cell;vertical-align: middle;" :rowspan="row.total_contents" ><b>{{row.Numero}}</b></td>
                      <td class="center">{{row2.product_name}}</td>
                      <td class="center">{{row2.variety_name}}</td>
                      <td class="center">{{row2.origin_name}}</td>
                      <td class="center">{{row2.product_type_name}}</td>
                      <td class="center">{{row2.condition}}</td>
                      <td class="center">{{row2.container_name}}</td>
                      <td class="center">{{row2.quantity}}</td>
                      <td class="center">{{row2.specifications}}</td>
                      <td class="center">{{row2.gross_kilograms}}</td>
                      <td class="center">{{row2.net_kilograms}}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                      <td class="center">{{row2.product_name}}</td>
                      <td class="center">{{row2.variety_name}}</td>
                      <td class="center">{{row2.origin_name}}</td>
                      <td class="center">{{row2.product_type_name}}</td>
                      <td class="center">{{row2.condition}}</td>
                      <td class="center">{{row2.container_name}}</td>
                      <td class="center">{{row2.quantity}}</td>
                      <td class="center">{{row2.specifications}}</td>
                      <td class="center">{{row2.gross_kilograms}}</td>
                      <td class="center">{{row2.net_kilograms}}</td>
                      </tr>
                    </template>  
                  </template>
              </template>
                      <tr class="table-light">
                      <td class="center"><b>TOTAL:</b></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"></td>
                      <td class="center"><b> {{total_cajas}}</b></td>
                      <td class="center"></td>
                      <td class="center"><b>{{total_kg_brutos}}</b></td>
                      <td class="center"><b>{{total_kg_netos}}</b></td>
                      </tr>
            </tbody>
          </table>
        </div>
      </b-card-body>

    </b-card>

    <p>Detalle</p>
  </div>

</template>

<script>

import html2pdf from 'html2pdf.js'

export default {
  name: "",
  created() {
  },
   props: ["waybillID"],
  data() {
    return {
      total_cajas:0,
      total_kg_brutos:0,
      total_kg_netos:0,
      tableDataPalletGuia: [],
    
    };
  },
  mounted() {
       
this.getPalletWaybill();
   },
  methods: {
    printDiv: function() {

      const prtHtml = document.getElementById('areaImprimir').innerHTML;
      let stylesHtml = '';
  
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      const WinPrint = window.open('', '', 'left=0,top=0,width=1000,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();

    },
     descargarPDF: function() {

  var element = document.getElementById('areaImprimir').innerHTML;

  var opt = {
      margin:       0.1,
      filename:     'despacho-'+this.waybillData.numero_guia,
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'landscape' }
    };
 
    html2pdf(element,opt);
  
    },
     calcular: function() {

          this.total_kg_brutos=0;
          this.total_kg_netos=0;
          this.total_cajas=0;

          for (var indice in  this.tableDataPalletGuia) 
          {
            for (var indice2 in  this.tableDataPalletGuia[indice].contents_data) 
            {
              this.total_kg_brutos+=parseFloat(this.tableDataPalletGuia[indice].contents_data[indice2].gross_kilograms);
              this.total_kg_netos+=parseFloat(this.tableDataPalletGuia[indice].contents_data[indice2].net_kilograms);
              this.total_cajas+=parseFloat(this.tableDataPalletGuia[indice].contents_data[indice2].quantity);
            }
          }

  },
    getPalletWaybill() {
       

      this.$axios
        .get("/api/v1/allstock/"+this.waybillID+"/getAllInfoPalletGuia/")
        .then(res => {
       
          const data = res.data.data;
         

      
    if (res.data.status == 1) 
    {
          for (let key in data) {
            

             var rowNew = {
              Numero: data[key].number,
              Kilos_brutos: data[key].total_gross_kilograms,
              Kilos_netos: data[key].total_net_kilograms,
              id_pallet: data[key].id,
              total_contents: data[key].total_contents,
              contents_data: data[key].contents
            };
            this.tableDataPalletGuia.push(rowNew);


          }

          this.calcular();

        }

        })
        .catch(error => console.log(errors));
    }
  },
  computed: {},
   beforeMount() {
   }
};
</script>

<style lang="scss">
  
   table { page-break-inside:auto }
   tr    { page-break-inside:avoid; page-break-after:auto }

   #dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}

</style>
